import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const SCROLLBAR_SIZE = 6;
const SCROLLBAR_BORDER_RADIUS = themeGet('borderRadius.md');
const SCROLLBAR_TRACK_BACKGROUND = 'gray.50';
const SCROLLBAR_THUMB_COLOR = 'gray.200';
const SCROLLBAR_THUMB_COLOR_HOVER = 'gray.300';
export const scrollbar = (options) => {
    const { trackMargin, trackBackground = SCROLLBAR_TRACK_BACKGROUND, trackSize = SCROLLBAR_SIZE, thumbColor = SCROLLBAR_THUMB_COLOR, thumbColorHover = SCROLLBAR_THUMB_COLOR_HOVER, } = options || {};
    const trackSizeRem = pxToRem(trackSize);
    return css `
    &::-webkit-scrollbar {
      width: ${trackSizeRem};
      height: ${trackSizeRem};
    }

    &::-webkit-scrollbar-track {
      margin-top: ${trackMargin && themeGet(`spacing.${trackMargin}`)};
      margin-bottom: ${trackMargin && themeGet(`spacing.${trackMargin}`)};
      border-radius: ${SCROLLBAR_BORDER_RADIUS};
      background: ${themeGet(`colors.${trackBackground}`)};
    }

    &::-webkit-scrollbar-thumb {
      width: ${trackSizeRem};
      height: ${trackSizeRem};
      background: ${themeGet(`colors.${thumbColor}`)};
      border-radius: ${SCROLLBAR_BORDER_RADIUS};

      &:hover {
        background: ${themeGet(`colors.${thumbColorHover}`)};
      }
    }
  `;
};
